import { AllUsers } from "../../interfaces/identity/calendar/Events";

export function toShortAmPm(time: string) {
    if (!time) return '';
    let [h, m] = time.split(':').map(Number);
    let ampm = h >= 12 ? 'pm' : 'am';
    let hour = h % 12 === 0 ? 12 : h % 12;
    // Only show minutes if not 00
    return m === 0 ? `${hour}${ampm}` : `${hour}:${m < 10 ? '0' : ''}${m}${ampm}`;
}


// Helper to convert "10:07am" or "11:07pm" to "HH:mm" 24-hour format
export function to24Hour(time: string): string {
    if (!time) return "";
    // If already in 24-hour format (HH:mm)
    if (/^\d{2}:\d{2}$/.test(time)) return time;
    // Match "hh:mmam/pm" or "hham/pm"
    const match = time.match(/^(\d{1,2})(?::(\d{2}))?(am|pm)$/i);
    if (!match) return "";
    let [, hour, minute, period] = match;
    let h = parseInt(hour, 10);
    let m = minute ? parseInt(minute, 10) : 0;
    if (period.toLowerCase() === "pm" && h !== 12) h += 12;
    if (period.toLowerCase() === "am" && h === 12) h = 0;
    return `${h.toString().padStart(2, "0")}:${m.toString().padStart(2, "0")}`;
}

export const getSortIcon = (active: boolean, direction: string) => {
    if (!active) return "⇅";
    return direction === "asc" ? "▲" : "▼";
};


export const GetUserWhoNotHaveEmails = (
  allusers: AllUsers[],
  selectededUserIds: string[]
): string[] => {
  const selectedUserIdSet = new Set(selectededUserIds);

  return allusers
    .filter(
      user =>
        selectedUserIdSet.has(user.userId) &&
        (!user.email || user.email.trim() === "")
    )
    .map(user => user.userId);
};
